/**
 * Clio brand colors from their SSO button guidelines:
 * https://docs.developers.clio.com/guides/sso/sso-button-guidelines/
 */
export const CLIO_BLUE = '#0070E0';
export const CLIO_BLUE_DARK = '#0F478D';
export const CLIO_BLUE_SOFT = '#E8F2FC';
